import './polyfills/polyfills';
import Alpine from 'alpinejs';
import Collapse from '@alpinejs/collapse';
import Focus from '@alpinejs/focus';
import Slide from './alpine/directives/slide';
import Carousel from './components/carousel';
import './modules/lightbox';
import { AjaxRequest, AjaxMethod } from './modules/ajax';
import './extensions/object';
import Maps from './components/maps';
import PrivacyPolicy from './components/privacypolicy';
import Forms from './components/forms';
import AnimatedCounter from './components/animatedcounter';
import InstantPrefetch from './components/instantprefetch';
import Embeds from './components/embeds';
Alpine.plugin(Slide);
Alpine.plugin(Collapse);
Alpine.plugin(Focus);
window.Alpine = Alpine;
Alpine.data('overlayMenu', () => ({
    open: false,
    toggleMenu(open) {
        this.open = open != undefined ? open : (this.open == true ? false : true);
        if (this.open == false) {
            this.dropdownOpen = "";
        }
    },
    dropdownOpen: '',
    get dropdownOpenPath() {
        let path = [];
        let ids = this.dropdownOpen.split("/");
        let temp = "";
        ids.forEach((e) => {
            temp += e;
            path.push(temp);
            temp += "/";
        });
        return path;
    },
    isDropdownOpen(id) {
        let paths = this.dropdownOpenPath;
        for (let i = 0; i < paths.length; i++) {
            if (paths[i] == id) {
                return true;
            }
        }
        ;
        return false;
    },
    toggleDropdown(id) {
        if (this.dropdownOpen == id) {
            if (this.dropdownOpen.lastIndexOf("/") > -1) {
                this.dropdownOpen = this.dropdownOpen.substring(0, this.dropdownOpen.lastIndexOf("/"));
            }
            else {
                this.dropdownOpen = "";
            }
        }
        else {
            this.dropdownOpen = id;
        }
    }, init() { }
}));
Alpine.data('sideMenu', () => ({
    open: false,
    toggleMenu(open) {
        this.open = open != undefined ? open : (this.open == true ? false : true);
        if (this.open == false) {
            this.dropdownOpen = "";
        }
    },
    dropdownOpen: '',
    get dropdownOpenPath() {
        let path = [];
        let ids = this.dropdownOpen.split("/");
        let temp = "";
        ids.forEach((e) => {
            temp += e;
            path.push(temp);
            temp += "/";
        });
        return path;
    },
    isDropdownOpen(id) {
        let paths = this.dropdownOpenPath;
        for (let i = 0; i < paths.length; i++) {
            if (paths[i] == id) {
                return true;
            }
        }
        ;
        return false;
    },
    toggleDropdown(id) {
        if (this.dropdownOpen == id) {
            if (this.dropdownOpen.lastIndexOf("/") > -1) {
                this.dropdownOpen = this.dropdownOpen.substring(0, this.dropdownOpen.lastIndexOf("/"));
            }
            else {
                this.dropdownOpen = "";
            }
        }
        else {
            this.dropdownOpen = id;
        }
    }
}));
Alpine.start();
var NavigationType;
(function (NavigationType) {
    NavigationType["SideMenu"] = "sidemenu";
    NavigationType["OverlayMenu"] = "overlaymenu";
    NavigationType["Default"] = "default";
})(NavigationType || (NavigationType = {}));
class Main {
    constructor() {
        this.HeaderDefaultTheme = [];
        this.HeaderTransparentTheme = [];
        this.NavigationType = NavigationType.Default;
        var self = this;
        window.dispatchEvent(new CustomEvent("Bearbone::Loaded", {}));
        //new SVG();
        new InstantPrefetch();
        //new Navigation();
        new Carousel();
        new Maps();
        new PrivacyPolicy();
        new Forms();
        new AnimatedCounter();
        new Embeds();
        this.lazyLoad();
        this.lightboxes();
        this.ajaxPaging();
        if (window["AOS"])
            window["AOS"].init();
        self.Footer = document.getElementById("footer");
        self.Header = document.getElementById("header");
        self.Main = document.getElementById("wrapper");
        let firstSection = self.Main.getElementsByTagName('section')[0];
        let hasRichModule = (!document.body.classList.contains("disable-transparent-header") && (firstSection && firstSection.classList.contains("rich-module")));
        let transparentHeader = document.body.classList.contains("transparent-header");
        if (hasRichModule) {
            document.body.classList.add("has-rich-module");
            document.body.classList.add("transparent-header");
        }
        else {
            document.body.classList.remove("transparent-header");
        }
        if (document.body.classList.contains("side-navigation")) {
            this.NavigationType = NavigationType.SideMenu;
        }
        else if (document.body.classList.contains("overlay-navigation")) {
            this.NavigationType = NavigationType.OverlayMenu;
        }
        var headerHeight = self.Header?.offsetHeight;
        if (headerHeight > 100)
            headerHeight = 100;
        self.sizeCheck();
        window.addEventListener("scroll", function () {
            if (window.pageYOffset > headerHeight) {
                document.body.classList.add("is-scrolled");
            }
            else {
                document.body.classList.remove("is-scrolled");
            }
        });
        window.dispatchEvent(new CustomEvent("Bearbone::Initialized", {}));
        if (this.isPreview()) {
            this.setPreview();
        }
        this.underlines();
    }
    isPreview() {
        return window?.frameElement?.baseURI?.indexOf("umbraco/preview") > -1;
    }
    setPreview() {
        const channel = new BroadcastChannel('backoffice-data');
        channel.addEventListener('message', (event) => {
            if (event.data.event.startsWith('backoffice-')) {
                switch (event.data.event) {
                    case "backoffice-blockfocus":
                        document.querySelectorAll(".editor-focus").forEach((element) => {
                            element.classList.remove("editor-focus");
                        });
                        if (event.data.id != null) {
                            let element = document.querySelector(".module-" + event.data.id + ",.widget-" + event.data.id);
                            if (element) {
                                element.classList.add("editor-focus");
                                //element.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
                            }
                        }
                        break;
                }
            }
        });
    }
    sizeCheck() {
        let self = this;
        document.addEventListener("DOMContentLoaded", function (event) {
            self.checkSize();
            if (window["AOS"])
                window["AOS"].refresh();
        });
        window.onresize = () => {
            self.checkSize();
        };
        Promise.all(Array.from(document.images)
            .filter(img => !img.complete)
            .map(img => new Promise(resolve => { img.onload = img.onerror = resolve; }))).then(() => {
            self.checkSize();
            if (window["AOS"])
                window["AOS"].refresh();
        });
        var observer = new MutationObserver(function () {
            self.checkSize();
            if (window["AOS"])
                window["AOS"].refresh();
        });
    }
    lazyLoad() {
        try {
            // @ts-ignore
            const lazyContent = new LazyLoad({
                use_native: true,
                callback_error: (img) => {
                    console.log(img);
                }
            });
        }
        catch { }
    }
    checkSize() {
        if (this.Footer) {
            let footerSize = this.Footer.getBoundingClientRect();
            document.body.style.setProperty('--footer-height', Math.round(footerSize.height) + "px");
            document.body.style.setProperty('--footer-width', Math.round(footerSize.width) + "px");
        }
        if (this.NavigationType != NavigationType.SideMenu && this.Header) {
            let headerSize = this.Header.getBoundingClientRect();
            document.body.style.setProperty('--header-height', Math.round(headerSize.height) + "px");
            document.body.style.setProperty('--header-width', Math.round(headerSize.width) + "px");
        }
        document.body.classList.toggle("floating-footer", document.body.clientHeight <= window.innerHeight);
    }
    underlines() {
        document.addEventListener("DOMContentLoaded", function (event) {
            var headlines = document.querySelectorAll("h1, h2, h3, h4");
            if (headlines) {
                headlines.forEach((headline) => {
                    headline.innerHTML = headline.innerHTML.replace(/\*([^*]+)\*/g, '<span class="underline">$1</span>');
                });
            }
        });
    }
    lightboxes() {
        let anchors = document.querySelectorAll(".lightbox");
        anchors.forEach(item => {
            item.lightBox({ disableScrollOnOpen: true });
        });
    }
    inViewport(element, options = { offset: { top: 0, right: 0, bottom: 0, left: 0 }, threshold: 0 }) {
        const { top, right, bottom, left, width, height } = element.getBoundingClientRect();
        const intersection = {
            t: bottom,
            r: window.innerWidth - left,
            b: window.innerHeight - top,
            l: right
        };
        const threshold = {
            x: options.threshold * width,
            y: options.threshold * height
        };
        return intersection.t > (options.offset.top + threshold.y)
            && intersection.r > (options.offset.right + threshold.x)
            && intersection.b > (options.offset.bottom + threshold.y)
            && intersection.l > (options.offset.left + threshold.x);
    }
    ajaxPaging() {
        let initial = document.querySelectorAll(".pagelist-content");
        let buttons = document.querySelectorAll(".ajax-paging");
        if (initial.length > 0) {
            initial.forEach((item, key) => {
                loadInitial(item);
            });
        }
        if (buttons.length > 0) {
            buttons.forEach((button, key) => {
                let parameters = getParameters(button);
                if (parameters.page >= parameters.pages) {
                    button.remove();
                }
                button.addEventListener("click", (e) => {
                    e.preventDefault();
                    load(e.target);
                });
            });
        }
        function getParameters(button) {
            let data = button.getData();
            return {
                url: button.getAttribute("href") != null ?
                    button.getAttribute("href") : decodeHTMLEntities(data.url),
                target: data.target,
                page: parseInt(data.page),
                pages: parseInt(data.pages)
            };
        }
        function decodeHTMLEntities(text) {
            var textArea = document.createElement('textarea');
            textArea.innerHTML = text;
            return textArea.value;
        }
        function load(button) {
            button.setAttribute("disabled", "disabled");
            let parameters = getParameters(button);
            let ajax = new AjaxRequest();
            ajax.Send(AjaxMethod.GET, parameters.url, {
                page: parameters.page + 1
            }).then(results => {
                let holder = document.querySelector(parameters.target);
                holder.innerHTML += results.data;
                if (parameters.page + 1 >= parameters.pages) {
                    button.remove();
                }
                else {
                    button.setData("page", parameters.page + 1);
                    button.setData("index", parameters.page + 1);
                }
                button.removeAttribute("disabled");
            }, error => {
                button.removeAttribute("disabled");
            });
        }
        function loadInitial(item) {
            let parameters = getParameters(item);
            let ajax = new AjaxRequest();
            ajax.Send(AjaxMethod.GET, parameters.url, {
                page: parameters.page
            }).then(results => {
                let holder = document.querySelector(parameters.target);
                holder.innerHTML += results.data;
            }, error => {
            });
        }
    }
}
window["Main"] = new Main();
